export const WORKS_DATA = "WORKS_DATA";
export const WORKS_DATA_LOADING = "WORKS_DATA_LOADING";
export const WORKS_REMOVE = "WORKS_REMOVE";
export const SEND_RATING_WORKS_SUCCESS = "SEND_RATING_WORKS_SUCCESS";
export const RATING_WORKS_IS_SENDING = "RATING_WORKS_IS_SENDING";
